import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { ButtonMain, CheckPassword, InputMain } from "components";
import { authActions, httpRequestsOnErrorsActions } from "store";
import { FindErrorItem, FindLoad, PasswordValidator } from "utils";
import { Svg } from "assets";
import { checkPassword } from "./constants";

const ACTION_TYPE = "RESET_PASSWORD_REQUEST";

export const ResetModal = ({}) => {
  const {
    handleSubmit,
    control,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      newPassword: "",
      confirmation: "",
    },
  });
  const dispatch = useDispatch();
  const [showPasswords, setShowPasswords] = useState({
    newPassword: false,
    confirmation: false,
  });
  const loader = FindLoad(ACTION_TYPE);
  const backError = FindErrorItem(ACTION_TYPE);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const resetToken = searchParams.get("resetToken");
  const register = searchParams.get("token");
  const userEmail = searchParams.get("email");
  const beckErrorMessage =
    backError?.error ===
    "Your session is expired, please login again or token is invalid"
      ? "Your session is expired"
      : backError?.error ===
          "This profile is not eligable for registration completion at this time"
        ? backError?.error
        : errors?.identify?.message ===
            "User Identification with this resource was not found."
          ? "User Identification with this email was not found."
          : "";

  useEffect(() => {
    dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    clearErrors();

    return () => {
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
      clearErrors();
    };
  }, []);

  useEffect(() => {
    if (watch("newPassword") !== watch("confirmation")) {
      setError("confirmation", {
        message: "Password and confirm password does not match",
      });
    } else {
      clearErrors("confirmation");
    }
  }, [watch("confirmation")]);

  const resetPassword = (data) => {
    clearErrors("identify");
    const { newPassword, confirmation } = data;

    const passwords = {
      newPassword: data.newPassword,
      confirmation: data?.confirmation,
      token: register ? register : resetToken,
      type: register ? "register" : "reset",
    };

    if (newPassword === confirmation) {
      dispatch(authActions.resetPassword(passwords, userEmail));
    } else {
      setError("confirmation", {
        message: "Password and confirm password does not match",
      });
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <Svg.ResetSvg className="login-main-svg" />

        <h3 className="login-title">
          {resetToken ? "Reset Password" : "Complete Registration"}
        </h3>

        <p className="login-description">
          {resetToken
            ? "Enter your new password."
            : `You have been invited to join CareTech. Please create your password to complete your registration.`}
        </p>
        <form className="login-form" onSubmit={handleSubmit(resetPassword)}>
          <InputMain
            variant="outlined"
            name="newPassword"
            type="password"
            showPassword={showPasswords.newPassword}
            control={control}
            placeholder={register ? "Password" : "New Password"}
            labelHeader={register ? "Password" : "New Password"}
            minLength={8}
            rules={{
              required: "New password is required.",
              pattern: {
                value: PasswordValidator,
                message: "Not valid password",
              },
            }}
            onClickIconEnd={() =>
              setShowPasswords((prev) => ({
                ...prev,
                newPassword: !prev.newPassword,
              }))
            }
            startAdornment={<Svg.LockPassSvg />}
          />

          <InputMain
            variant="outlined"
            name="confirmation"
            type="password"
            showPassword={showPasswords.confirmation}
            control={control}
            placeholder={register ? "Confirm Password" : "Confirm New Password"}
            labelHeader={register ? "Confirm Password" : "Confirm New Password"}
            minLength={8}
            rules={{
              required: "Confirm password is required.",
            }}
            onClickIconEnd={() =>
              setShowPasswords((prev) => ({
                ...prev,
                confirmation: !prev.confirmation,
              }))
            }
            startAdornment={<Svg.LockPassSvg />}
          />
          {beckErrorMessage && (
            <p className="error-message">{beckErrorMessage}</p>
          )}

          <CheckPassword
            fields={checkPassword}
            text={watch("newPassword")}
            isActive={watch("newPassword")}
          />

          <ButtonMain
            type="submit"
            load={!!loader?.length}
            text={register ? "Complete Registration" : "Reset Password"}
            buttonMainStyles={{ marginTop: 16 }}
          />
        </form>
      </div>
    </div>
  );
};
